import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "nodes-embed ansicolor-on matchednodes embed embed_clean" }
const _hoisted_2 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_node_show_embed = _resolveComponent("node-show-embed")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodes, (node, i) => {
          return (_openBlock(), _createBlock(_component_node_show_embed, {
            key: `node-${i}`,
            node: node,
            class: _normalizeClass(_ctx.cssForNode(node.attributes)),
            "show-exclude-filter-links": _ctx.showExcludeFilterLinks,
            onFilter: _ctx.filterClick
          }, null, 8, ["node", "class", "show-exclude-filter-links", "onFilter"]))
        }), 128))
      ])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}